/**
 * Shortens the text for the provided text and number of characters to
 * shorten it till.
 * @param {string} text
 * @param {Number} maxChars
 * @returns {string} shortened string
 */
export const truncateText = (text, maxChars) => {
  /**
   * if the text's length is greater than 10 characters then,
   * return the subtring of the first maxChars characters. else,
   * return the text itself.
   * */
  return text?.length > 10 ? text?.substring(0, maxChars) + '...' : text
}

export const splitCamelCase = (str) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2') // Insert dash between lowercase and uppercase letters
    .toLowerCase() // Convert to lowercase
}

export const camelToKebab = (str) => {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
    .toLowerCase()
}

export const kebabToCamel = (str) => {
  return str.replace(/-([a-z])/g, (_, char) => char.toUpperCase())
}

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
